import CopyButton from "@/components/CopyButton";
import PageBack from '@/components/PageBack';
import RpIcon from "@/components/RpIcon";
import RouteConstant from "@/constant/RouteConstant";
import useSettings from "@/hook/useSettings";
import { useUserVariteies } from "@/pages/Deposit/hooks";
import MobileLanguageSelector from "@/pages/components/MobileLanguageSelector";
import KYCCard from "@/pages/kyc/components/KYCCard";
import { onToggleAccountDrawerOpen, onToggleWalletDrawerOpen } from "@/redux/slices/app";
import { setAmountVisible } from "@/redux/slices/assets";
import { onUserLogout, getHomeInfo } from "@/redux/slices/user";
import { dispatch } from "@/redux/store";
import { logout } from "@/services/user";
import { Badge, Box, Button, Divider, Drawer, Stack, styled, Typography, useTheme } from "@mui/material";
import { useBoolean } from "ahooks";
import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import AmountDisplay from "@/components/AmountDisplay";
import UserAssets from '@/components/UserAssets';
import VarietySelectModal from "@/pages/components/VarietySelectModal";
import { useConfirm } from "material-ui-confirm";
import { useState } from "react";
import "swiper/css";
import classes from "./index.module.less";
import NationAvatar from "@/components/NationAvatar";
import UserAvatar from "../UserAvatar";
import { setWithdrawInfo } from "@/redux/slices/assets";
import useIntercom from "@/hook/useIntercom";

const StyledNationAvatar = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '-5px',
  right: '0',
  width: '16px',
  height: '16px',
}));

const MobileAccountInfo = () => {
  const {settings} = useSettings();
  const {t} = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const confirm = useConfirm();

  const {user, loading, homeInfo, zendeskUnreadMessageCount, unreadMessageCount } = useSelector((state) => state.user);
  const {accountDrawerOpen, walletDrawerOpen} = useSelector((state) => state.app);
  const {amountVisible} = useSelector((state) => state.assets);
  // const [walletDrawerOpen, walletDrawerOpenOperate] = useBoolean(false);
  const [isLanguageSelectorOpen, languageSelectorOperate] = useBoolean(false);

  const [varietyOperate, setVarietyOperate] = useState('')

  const [varietySelectModalOpen, varietySelectModalOpenOperate] = useBoolean(false);
  const {showIntercom} = useIntercom()
 
  const onLogout = async () => {
    confirm({
      description: t('logout_confirm'),
      confirmationText: t('confirm'),
      cancellationText: t('cancel'),
    }).then(() => {
      _doLogout();
    });
  };

  const _doLogout = async () => {
    try {
      await logout();
      dispatch(onUserLogout());

      enqueueSnackbar(t("log_out_toast"), {variant: "success"});
      navigate(`${RouteConstant.LOGIN}?mode=login`, { replace: true });
    } catch (e) {
      console.error(e);
    }
  }

  const _onToggleAccountDrawerOpen = () => {
    dispatch(onToggleAccountDrawerOpen());
  }

  const _onToggleWalletDrawerOpen = () => {
    dispatch(onToggleWalletDrawerOpen());
  }

  const _onDeposit = () => {
    // navigate(RouteConstant.DEPOSIT_VARIETY_SELECT);
    // walletDrawerOpenOperate.setFalse()
    setVarietyOperate('deposit')
    varietySelectModalOpenOperate.setTrue()
  }

  const _onWithdraw = () => {
    setVarietyOperate('withdraw')
    dispatch(setWithdrawInfo({
      address: '',
      amount: '',
      network: null,
    }))
    // navigate(RouteConstant.WITHFRAW_VARIETY_SELECT);
    // walletDrawerOpenOperate.setFalse()
    varietySelectModalOpenOperate.setTrue()
  }

  // const renderRight
  const canGoBack = location.key === 'default';
  const inMainPage = (location.pathname == RouteConstant.MAIN || location.pathname == RouteConstant.HOME);

  const [selectedVariety, setSelectedVariety] = useState(null);
  const onVarietySelected = (variety) => {
    setSelectedVariety(variety)

    if (varietyOperate === 'deposit')
      navigate(`${RouteConstant.USER_DEPOSIT}?variety_code=${variety.varietyCode}`)
    if (varietyOperate === 'withdraw')
      navigate(`${RouteConstant.USER_WITHDRAW}?variety_code=${variety.varietyCode}`)
  }

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        // gap={"24px"}
        className={classes.root}
        sx={{ 
          position: 'relative',
          height: '30px',
          width: '100%',
        }}
      >
        <Stack direction={'row'} alignItems={'center'} spacing={2} sx={{
          position: 'absolute',
          left: 0,
        }}>
          {!inMainPage && canGoBack &&
            <PageBack onClick={() => {
              navigate(-1)
            }} />
          }
          {inMainPage && <UserAvatar size={30} nationSize={14} onClick={_onToggleAccountDrawerOpen} />}
        </Stack>

        <Box sx={{ width: '100%', textAlign: 'center' ,display:"flex",alignItems:"center",justifyContent:"center"}}>
          {/* <img src="/images/logo-light.svg"/> */}
          <img style={{height:"30px"}} src="/images/logo-sonic-dark.svg"/>
        </Box>
        
        <Stack
          sx={{
            border: `1px solid ${theme.palette.background.paper}`,
            padding: '4px 8px',
            borderRadius: '24px',
            position: 'absolute',
            right: 0,
            cursor:"pointer"
          }}
          direction="row" alignItems="center" variant="contained" onClick={() => {
          dispatch(getHomeInfo());
          _onToggleWalletDrawerOpen()
        }}>
          <RpIcon icon={'eWallet'} size={18}/>
          <Typography sx={{marginLeft: '8px'}}>{t('wallet')}</Typography>
        </Stack>
        {/*<IconButton onClick={_onToggleAccountDrawerOpen}>*/}
        {/*  <RpIcon icon={'account'} />*/}
        {/*</IconButton>*/}
        {/*<Message badgeContent={5}/>*/}
      </Stack>

      {/* 左边account drawer */}
      <Drawer
        open={accountDrawerOpen}
        onClose={_onToggleAccountDrawerOpen}
        anchor="left"
      >
        <Box className={classes["drawer-account-wrap"]}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" className={classes.header}>
            <Box onClick={_onToggleAccountDrawerOpen}><RpIcon icon="arrow-left" size={22}/></Box>
            <Stack direction="row" gap={3}>
              <Box onClick={() => {navigate(RouteConstant.MESSAGE_LIST)}}>
                <Badge color="error" variant="dot" invisible={!unreadMessageCount}>
                  <RpIcon icon="bell" size={22}/>
                </Badge>
              </Box>
            </Stack>
          </Stack>
          <Stack className={classes["userInfo-wrap"]} direction="row">
            {/* <Box className={classes['avatar']} sx={{ position: 'relative' }}>
              {user?.username?.charAt(0)}
              <StyledNationAvatar>
                <NationAvatar code={user?.kycNationCode2} size={'16px'} />
              </StyledNationAvatar>
            </Box> */}
            <UserAvatar size={48} fontSize={24} nationSize={18} />
            <Box>
              <p className={classes['account']}>{user?.email}</p>
              <Stack direction="row" alignItems={'center'} gap={0.5}>
                <p className='span'>ID: {user?.uid}</p>
                <CopyButton color={""} value={user?.uid} size={12}/>
              </Stack>
              <Box className={classes['kyc-status']}><KYCCard/></Box>
            </Box>
          </Stack>
          <Stack
            direction="row"
            justifyContent={'space-between'}
            alignItems="center"
            className={classes['account-center-list']}
            onClick={() => {navigate(RouteConstant.USER_SECURITY)}}
          >
            <Stack direction="row" gap={'12px'}>
              <RpIcon icon="safe" size={22}/>
              {/*<SecurityCard/>*/}
              {t('security')}
            </Stack>
            <RpIcon icon="arrow-right-simple" size={18}/>
          </Stack>

          <Stack
            direction="row"
            onClick={() => {showIntercom()}}
            justifyContent={'space-between'}
            alignItems="center"
            className={classes['account-center-list']}
          >
            <Stack direction="row" gap={'12px'}>
              <RpIcon icon="help" size={22}/>
              <p>{t('support_center')}</p>
            </Stack>
            <RpIcon icon="arrow-right-simple" size={18}/>
          </Stack>

          <Stack
            direction="row"
            onClick={() => {languageSelectorOperate.setTrue()}}
            justifyContent={'space-between'}
            alignItems="center"
            className={classes['account-center-list']}
          >
            <Stack direction="row" gap={'12px'}>
              <RpIcon icon="lang" size={22}/>
              <p>{t('language')}</p>
            </Stack>
            <RpIcon icon="arrow-right-simple" size={18}/>
          </Stack>
          {/*<Stack direction="row" alignItems="center" justifyContent={'space-between'} className={classes['account-center-list']}>*/}
          {/*  <Stack direction="row" gap={'12px'}>*/}
          {/*    <RpIcon icon="theme" size={22}/>*/}
          {/*    <p>{t('appearance')}</p>*/}
          {/*  </Stack>*/}
          {/*  <MobileThemeIconButton/>*/}
          {/*</Stack>*/}

          <Stack
            direction="row"
            alignItems="center"
            justifyContent={'space-between'}
            className={classes['account-center-list']}
            onClick={onLogout}
          >
            <Stack direction="row" gap={'12px'}>
              <RpIcon icon="log_out" size={22}/>
              <p>{t('logout')}</p>
            </Stack>
            <RpIcon icon="arrow-right-simple" size={18}/>
          </Stack>
        </Box>
      </Drawer>

      {/* 右边钱包drawer */}
      <Drawer
        open={walletDrawerOpen}
        onClose={_onToggleWalletDrawerOpen}
        anchor="right">
        <Stack
          sx={theme => {
            return {
              minWidth: '300px',
              minHeight: '100%',
            }
          }}
        >
          <Stack>
            <Box className={'container-wrap'}>
              <Stack direction="row" justifyContent="space-between">
                <RpIcon icon="arrow-left"
                        clickable
                        onClick={() => {
                          _onToggleWalletDrawerOpen()
                        }}
                        size={24}/>
                <RpIcon icon="file"
                        clickable
                        onClick={() => {
                          navigate(RouteConstant.ASSETS_TRANS_LIST);
                        }}
                        size={24}/>
              </Stack>
              <Stack direction="row" alignItems={'center'} gap={'10px'} sx={{marginTop:'26px'}}>
                <Box className={'small'}>{t('total_balance')}</Box>
                <RpIcon size={22} icon={amountVisible ? 'eye_open' : 'eye_close'} clickable
                  onClick={() => {
                    dispatch(setAmountVisible(!amountVisible))
                  }}
                />
              </Stack>
              <Stack className={'text-primary-bold'} direction={'row'} alignItems={'flex-end'} spacing={1} alignContent={'center'}>
                <AmountDisplay
                  fontSize={'32px'}
                  fontWeight={700}
                  visible={amountVisible as Boolean} amount={`${homeInfo?.assetUser.available}`} />
                <Typography fontSize={'32px'} fontWeight={700}>{homeInfo?.assetUser.currencyCode}</Typography>
              </Stack>
              <Stack
                direction="row" gap="18px"
                sx={({
                  marginTop:'20px',
                  '& > button': {
                    borderRadius: '16px',
                    flex: 1
                  }
                })}>
                <Button
                  sx={theme => ({
                    backgroundColor: theme.palette.background.avatar,
                    color: theme.palette.primary.contrastText,
                    borderRadius: '32px!important',
                    padding: '8px 0',
                    fontSize: '13px'
                  })}
                  variant="contained" size="small" onClick={_onDeposit}>
                  <Stack direction={'row'} gap={'6px'} alignItems={'center'}>
                    <span className={'icon-deposit'}><RpIcon icon="plus_sign" size={14}/></span>
                    <span>{t("deposit")}</span>
                  </Stack>
                </Button>
                <Button
                  sx={theme => ({
                    backgroundColor: theme.palette.background.card,
                    color: theme.palette.text.primary,
                    borderRadius: '32px!important',
                    padding: '8px 0',
                    fontSize: '13px'
                  })}
                  size="small" onClick={_onWithdraw}>
                  <Stack direction={'row'} gap={'6px'} alignItems={'center'}>
                    <RpIcon icon="minus_sign" size={18}/>&nbsp;
                    <span>{t("withdraw")}</span>
                  </Stack>
                </Button>
              </Stack>
            </Box>
            <Divider sx={{margin:'8px 0', borderColor: theme.palette.borderColor?.divider, borderWidth: '0.5px' }} />
            <Box className={'container-wrap'}>
              <UserAssets amountVisible={amountVisible} list={homeInfo?.assetUser?.accountList} />
            </Box>
          </Stack>
        </Stack>
      </Drawer>
      <VarietySelectModal open={varietySelectModalOpen}
                          varietyOperate={varietyOperate}
                          onClose={varietySelectModalOpenOperate.setFalse}
                          onSelected={onVarietySelected}
      />
      <MobileLanguageSelector
        open={isLanguageSelectorOpen}
        onClose={languageSelectorOperate.setFalse}
      />
    </>
  );
};

export default MobileAccountInfo;
